module.exports = __webpack_public_path__ + "img/12.c6357ded.png";